import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function FetPatientsTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index]) {
      return 'N/A';
    }
    if (key.includes('frozenDetails')) {
      if (!data[index].frozenDetails) {
        return 'N/A';
      }

      if (
        data[index].frozenDetails[key.split('.')[1]] === null ||
        data[index].frozenDetails[key.split('.')[1]] === ''
      ) {
        return 'N/A';
      }
      return data[index].frozenDetails[key.split('.')[1]] ?? 'N/A';
    }
    if (data[index][key] === null || data[index][key] === '') {
      return 'N/A';
    }
    return data[index][key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={7}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            PATIENT DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            {' '}
            <div
              style={{
                height: '60px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Cycle Id
            </div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            {' '}
            <div
              style={{
                height: '60px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Patient Name
            </div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>Patient ID</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Patient Age</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Treating Physician</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Oocytes Self/OD</TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            Sperm (Self/DS)
          </TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('cycleId', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('patientName', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('upid', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('patientAge', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('frozenDetails.embryologist', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {' '}
                  {getCellData('frozenDetails.caseTypeOoctye', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('frozenDetails.caseTypeSperm', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default FetPatientsTable;
